/* eslint-disable no-param-reassign */
import _ from 'underscore';
import { panelDecorator } from '@bingads-webui-campaign-react/panel-decorator';
import { CreateConversionGoalView } from '@bingads-webui-campaign/recommendation-inline-create-conversion-goal-view';
import { PANEL_DECORATOR_TITLE, PANEL_WIDTH } from '../const';

const removeElement = (name) => {
  const container = document.querySelector('.create-conversion-goal-edit-content');
  if (!_.isNull(container.querySelector(name))) {
    container.querySelector(name).remove();
  }
}

export const openCreateConversionGoalEditor = (
  deps,
  i18n,
  newI18n,
  type,
  gridService,
  recommendation,
  router,
  isMCC,
  gridView,
  readOnly,
  editor,
  apply,
  perfMarker,
  serverContext,
  getGoalCreationRecommendationWizard
) => {
  const panelOptions = {
    width: PANEL_WIDTH[type],
    i18n,
    panelReadyAriaLabel: i18n.getString('Association editor side panel opened'),
    panelClassName: 'ad-editor-panel recommend-ad-editor-panel recommend-create-conversion-goal-editor-panel',
  };
  const EditorCtor = panelDecorator(CreateConversionGoalView, panelOptions);
  editor = new EditorCtor(_.extend(
    {
      title: newI18n.getString(PANEL_DECORATOR_TITLE[type]),
    },
    {
      eventsToActions: [{
        event: 'created',
        action: () => { editor.remove(); },
      }, {
        event: 'cancel',
        action: () => { editor.remove(); },
      }],
      onClose: () => { editor.remove(); },
    },
    {
      deps,
      data: recommendation,
      i18n,
      newI18n,
      router,
      type,
      gridView,
      readOnly,
      isMCC,
      scope: gridService.recommendationService.scope,
      gridService,
      permissions: deps.permissions,
      perfMarker,
      serverContext,
      getGoalCreationRecommendationWizard,
      applyAction: (opportunities, userInputs, context) => {
        apply(opportunities, userInputs, context, editor);
      },
    }
  )).render();

  // Remove some goal create wizard elements which are not included in editor page.
  removeElement('.step-header');
  removeElement('.conversion-wizard-footer');
};
